"use strict";
import _ from "underscore";
import Api from "../api/api";
var daysToPay = function(carrier) {
  var accountSettings = Api.Account.currentSettings();
  if (carrier.days_to_pay !== null && carrier.days_to_pay !== void 0) {
    return carrier.days_to_pay;
  }
  if (accountSettings.carrierDaysToPay !== null && accountSettings.carrierDaysToPay !== void 0) {
    return accountSettings.carrierDaysToPay;
  }
  return 30;
};
var quickpayDiscount = function(carrier) {
  var accountSettings = Api.Account.currentSettings();
  if (!_.isEmpty(carrier.quickpayDiscount)) {
    return carrier.quickpayDiscount;
  }
  if (accountSettings.quickpayDiscount) {
    return accountSettings.quickpayDiscount;
  }
  return null;
};
const isTransportationClient = (carrier) => !!carrier.transportation_client;
export default { daysToPay, quickpayDiscount, isTransportationClient };
